// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"39d52cb0","523":"14fe0a9f","535":"b0b89770","651":"a941c261","940":"1dc9de02"}[chunkId] + ".chunk.js";
};